module.exports = __webpack_public_path__ + "img/实时监控.cf8f8b8c.png";